import axios from "axios";
import { IP } from "../index.js";

// 查询
export async function selectList(data) {
  var resp = await axios.post(`${IP}/admin/money/selectMoney`, {
    ...data
  });
  return resp.data;
}

// 修改状态
export async function updateOrder(data) {
  var resp = await axios.post(`${IP}/admin/money/update`, {
    ...data,
  });
  return resp.data;
}

// 删除
export async function deleteMoney(data) {
  var resp = await axios.post(`${IP}/admin/money/delete`, { ...data });
  return resp.data;
}
